import React from 'react';
import { DialogContainer, DialogView } from './Dialog.styled';

import CloseIcon from '../../assets/icons/close.svg';

const Dialog = ({ dialogBody, handleClose, width = '' }) => {
  return (
    <DialogContainer>
      <DialogView width={width} open>
        <img
          className="close__icon"
          src={CloseIcon}
          alt="close"
          onClick={handleClose}
        />
        {dialogBody}
      </DialogView>
    </DialogContainer>
  );
};

export default Dialog;
